module.exports = __webpack_public_path__ + "static/media/15.102.7c087414.webp";